<template>
  <div>

    <ModalSolicitudFirma 
      :show_modal="dialog"
      :doc="array_files_obj"
      @childToParent="onChildClick">
    </ModalSolicitudFirma>

    <template v-for="(doc_, p1) in documentos_firmados">
      <v-container>
        <v-card color="#E5E5E5" outlined tile>
          <v-card-subtitle>
            <span>{{ doc_.nombre_archivo }}</span>
          </v-card-subtitle>
          <v-card-text>
            <p>
              <!--<v-btn color="warning" small class="mr-4" v-if="$route.name == 'details'"
                :to="{ name: 'documento_edit', params: {opt: 'firmar', id: doc_.paqueteId}}">
                <v-icon left>mdi-draw</v-icon>
                Firmar
              </v-btn> -->
              <v-btn color="info" @click="descargar(doc_.id)" small class="mr-4">
                <v-icon left>mdi-download</v-icon>
                Descargar
              </v-btn>
              <v-btn color="success" dark @click.stop="enviarCorreo(doc_)" small class="mr-4">
                <v-icon left>mdi-email</v-icon>
                Enviar por correo
              </v-btn>
              <v-btn color="pink" dark @click.stop="drawer = !drawer" small class="mr-4">
                <v-icon left>mdi-animation</v-icon>
                Bitacora
              </v-btn>
              <!--<span color="darken-3" class="mr-4" style="margin-left: 20px;">
                <v-icon left v-if="doc_.bloqueado">mdi-lock-check</v-icon>
                <v-icon rigth else>mdi-lock-open-variant</v-icon>
                ¿Bloqueado?
              </span>
              -->
            </p>

            <v-sheet color="#E5E5E5" class="overflow-hidden" style="position: relative;">
              <v-container class="fill-height">
                <v-row
                  align="center"
                  justify="center"
                >
                <template v-for="(page_, p2) in doc_.lista_paginas">
                  <img :src="'data:image/png;base64, ' + page_.base64">
                </template>
                </v-row>
              </v-container>
              <v-navigation-drawer
                v-model="drawer"
                absolute
                :right="true"
                temporary>
                <v-list-item>
                  <v-list-item-avatar>
                    <v-img src="@/assets/logo_infilesign.jpg"></v-img>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title>Firmas</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list dense>
                  <v-list-item v-for="(firmante_, p2) in doc_.resumen_firmantes" :key="p2" link>
                    <v-list-item-icon>
                      <v-icon v-if="firmante_.estado =='FIRMADO'">mdi-check-underline</v-icon>
                      <v-icon v-if="firmante_.estado =='PENDIENTE'">mdi-thumb-down-outline</v-icon>
                      <v-icon v-if="firmante_.estado =='RECHAZADO'">mdi-alert</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>{{ firmante_.email }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-navigation-drawer>
            </v-sheet>
          </v-card-text>
        </v-card>
      </v-container>
    </template>
  </div>
</template>
<script>
    import axios from "axios";
    import ModalSolicitudFirma from '@/components/documento/ModalSolicitudFirma.vue'; 
    
  export default {
  		props: ['paqueteId','firmado'],
      components: { ModalSolicitudFirma },
  		data: function() {
  		  return {
  		  	dialog: false,
          drawer: false,
          array_files_obj: [],
  		  	documentos_firmados: [],
  		  };
  		},
    	computed: {
    	},
    	mounted() {
        console.log(this.$route.name);
    		this.getDocumentosFirmados();
    	},
    	methods: {
  			getDocumentosFirmados()
  			{
  				let _this = this;
  				this.$store.dispatch('SET_OVERLAY');
  				let getdocs = axios.get('Paquete/documentos?paquete_id=' + this.paqueteId, { 'headers': this.$store.state.user.headers })
  				return getdocs.then((callback) => 
  				{
  				  if(callback.status == 200) {
  				    _this.documentos_firmados = callback.data;
  				  }
  				  this.$store.dispatch('UNSET_OVERLAY');
  				}).catch((error) => {
  					this.$store.dispatch('UNSET_OVERLAY');
  				    console.log(error);
  				});
  			},
  			descargar(doc_id){
  				console.log("descargando doc id: " +  doc_id);
  
  				this.$store.dispatch('SET_OVERLAY');
  				let getdocs = axios.get('Documento/descargar_pdf?id='+doc_id, { 'headers': this.$store.state.user.headers })
  				return getdocs.then((callback) => 
  				{
  				  if(callback.status == 200) {
    					let pdf_ = callback.data;
    					const linkSource = 'data:application/pdf;base64,' + pdf_;
    					const downloadLink = document.createElement("a");
    					const fileName = $('.v-card__subtitle span').html();
    
    					downloadLink.href = linkSource;
    					downloadLink.download = fileName;
    					downloadLink.click();
  				  } else {
              this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Hubo un error vuelva a intentar por favor.' });
  				  }
  				  this.$store.dispatch('UNSET_OVERLAY');
  				}).catch((error) => {
  					this.$store.dispatch('UNSET_OVERLAY');
            this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Hubo un error vuelva a intentar por favor.' });
  				  console.log(error);
  				});
  			},

        enviarCorreo(doc){
          this.dialog = true;
          this.array_files_obj=[];
          this.array_files_obj.push(doc);
        },
        onChildClick (obj) {
          let _this0 = this;
          //console.log(obj);
          this.dialog = obj.modal;
          if(obj.data.length > 0) {
            obj.data.forEach(function (item, index) {
              if(item.firmar && item.existe ){
                _this0.documentos_firmados[0].resumen_firmantes.push({ email: item.correo, estado: 'PENDIENTE' });
              }
            });
          }
        }
    	},
  };
</script>